import { AxiosResponse } from "axios";
import { LabelsResponse } from "../../@types/DRO/LabelsResponse";
import { erpAxios, getAuthToken } from "../axiosInstances";

export class LabelsApi {
  public static api = new LabelsApi();
  private instance = erpAxios;

  async getLabels(type: string): Promise<LabelsResponse> {
    const response: AxiosResponse<LabelsResponse> = await this.instance.get(
      "erp/api/v1/labels/fetch",
      {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
        params: { type },
      }
    );

    return response.data;
  }
}